module.exports = __webpack_public_path__ + "static/media/filterWhite.6b57ddd5.svg";